import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ComprarPage from "@/pages/ComprarPage";
import ConfirmacionPage from "@/pages/ConfirmacionPage";
import MisBoletosPage from "@/pages/MisBoletosPage";
import CheckinPage from "@/pages/CheckinPage";
import AsistentesPage from "@/pages/AsistentesPage";
import DonacionesPage from "@/pages/DonacionesPage";
import DonacionExitosaPage from "@/pages/DonacionExitosaPage";
import GaleriaPage from "@/pages/GaleriaPage";
import AdminPage from "@/pages/AdminPage";
import SponsorsPage from "@/pages/SponsorsPage";
import SponsorExitosoPage from "@/pages/SponsorExitosoPage";
import SponsorsPublicosPage from "@/pages/SponsorsPublicosPage";
import ContactoPage from "@/pages/ContactoPage";
import EventosGeneracionPage from "@/pages/EventosGeneracionPage";
import DirectorioPage from "@/pages/DirectorioPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/comprar" element={<ComprarPage />} />
          <Route path="/confirmacion" element={<ConfirmacionPage />} />
          <Route path="/mis-boletos/:compradorId" element={<MisBoletosPage />} />
          <Route path="/checkin" element={<CheckinPage />} />
          <Route path="/asistentes" element={<AsistentesPage />} />
          <Route path="/sponsors" element={<SponsorsPage />} />
          <Route path="/sponsor-exitoso" element={<SponsorExitosoPage />} />
          <Route path="/sponsors-publicos" element={<SponsorsPublicosPage />} />
          <Route path="/contacto" element={<ContactoPage />} />
          <Route path="/donaciones" element={<DonacionesPage />} />
          <Route path="/donacion-exitosa" element={<DonacionExitosaPage />} />
          <Route path="/galeria" element={<GaleriaPage />} />
          <Route path="/eventos" element={<EventosGeneracionPage />} />
          <Route path="/directorio" element={<DirectorioPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
